// src/SharedFilesPage.js
import React, { useState, useEffect } from 'react';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase.js';

function SharedFilesPage({ isMobile }) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const sharedRef = ref(storage, 'shared/');
        const result = await listAll(sharedRef);
        const filePromises = result.items.map(async (itemRef) => {
          const url = await getDownloadURL(itemRef);
          return { name: itemRef.name, url };
        });
        const fileList = await Promise.all(filePromises);
        setFiles(fileList);
      } catch (err) {
        console.error('Error listing shared files:', err);
        setError('Failed to load files');
      } finally {
        setLoading(false);
      }
    };
    fetchFiles();
  }, []);

  if (loading) return <p>Loading shared files...</p>;
  if (error) return <p className="text-red-500">{error}</p>;
  if (files.length === 0) return <p>No files in shared folder.</p>;

  return (
    <div className={`shared-files-page ${isMobile ? 'shared-files-page-mobile' : ''}`}>
      <h2>Shared Files (Publicly Accessible)</h2>
      <ul>
        {files.map((file) => (
          <li key={file.name}>
            <a href={file.url} download>{file.name}</a> - Direct download: {file.url}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SharedFilesPage;